import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_timeline = _resolveComponent("base-timeline")!

  return (_openBlock(), _createBlock(_component_base_timeline, {
    "pipeline-runs": $props.pipelineRuns.slice(0, 8),
    "show-layer-name": true
  }, null, 8, ["pipeline-runs"]))
}